'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { generateUuid } from '@lichtblick/localization';
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { useRef, useState } from 'react';
import { MTeaserItem } from '../MTeaserItem';
import styles from './slider.module.scss';
export const Slider = ({ items })=>{
    const [isPreviousControlEnabled, setIsPreviousControlEnabled] = useState(false);
    const [isNextControlEnabled, setIsNextControlEnabled] = useState(true);
    const skipCarouselAnchorMarkId = generateUuid().toString();
    const previousControlRef = useRef(null);
    const nextControlRef = useRef(null);
    const slidesRef = useRef(null);
    const slideItemsRef = useRef([]);
    const handleClick = (event)=>{
        const itemWidth = slideItemsRef.current[0]?.clientWidth ?? 0;
        slidesRef.current?.scrollBy({
            left: event.target === nextControlRef.current ? itemWidth : -itemWidth,
            top: 0,
            behavior: 'smooth'
        });
    };
    const handleKeyDown = (event)=>{
        if (event.key === 'Enter') {
            event.preventDefault();
            if (previousControlRef.current === event?.target) {
                previousControlRef.current?.click();
            } else {
                nextControlRef.current?.click();
            }
        }
    };
    const enableControls = ()=>{
        const scrollLeft = slidesRef.current?.scrollLeft ?? 0;
        const clientWidth = slidesRef.current?.clientWidth ?? 0;
        const scrollWidth = slidesRef.current?.scrollWidth ?? 0;
        if (scrollLeft === 0) {
            setIsPreviousControlEnabled(false);
        } else {
            setIsPreviousControlEnabled(true);
        }
        if (clientWidth === scrollWidth - scrollLeft) {
            setIsNextControlEnabled(false);
        } else {
            setIsNextControlEnabled(true);
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.slider,
        children: [
            /*#__PURE__*/ _jsx("a", {
                className: styles['skip-link'],
                href: `#${skipCarouselAnchorMarkId}`,
                children: /*#__PURE__*/ _jsx(Headline, {
                    size: "m",
                    children: "Carousel überspringen"
                })
            }),
            items.length > 4 && /*#__PURE__*/ _jsxs("div", {
                className: styles.controls,
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        "aria-disabled": !isPreviousControlEnabled,
                        "aria-label": "Pfeil links",
                        className: styles.control,
                        onClick: handleClick,
                        onKeyDown: handleKeyDown,
                        ref: previousControlRef,
                        tabIndex: 0,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles['icon-prev']
                        })
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        "aria-disabled": !isNextControlEnabled,
                        "aria-label": "Pfeil rechts",
                        className: styles.control,
                        onClick: handleClick,
                        onKeyDown: handleKeyDown,
                        ref: nextControlRef,
                        tabIndex: 0,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles['icon-next']
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.slides,
                onScroll: enableControls,
                ref: slidesRef,
                children: items.map((item, index)=>/*#__PURE__*/ _jsx("div", {
                        className: styles['slide-item'],
                        ref: (element)=>{
                            if (element) {
                                slideItemsRef.current[index] = element;
                            }
                        },
                        children: /*#__PURE__*/ _jsx(MTeaserItem, {
                            className: styles['teaser-item'],
                            ...item,
                            accentColor: 'black',
                            textOutside: true
                        })
                    }, item._uid))
            }),
            /*#__PURE__*/ _jsx("span", {
                id: skipCarouselAnchorMarkId
            })
        ]
    });
};

//# sourceMappingURL=slider.js.map